(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zerode-bike-enquiry"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('ZerodeBikeEnquiry');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const bikeHandles = new Set(['g3-downhill','shadow-deluxe','shadow-expert','shadow-origin','shadow-trail-deluxe','shadow-trail-expert','shadow-trail-origin','katipo-enduro','katipo-trail','taniwha-enduro','taniwha-trail','taniwha-mulet','taniwha-mullet-enduro','taniwha-mullet-trail','g3-short-ex-demo','g3-long-ex-demo']);
  // Cart contents are rebuilt asynchronously by Impulse after add/remove actions.
  const syncCartButtons = () => {
    document.querySelectorAll('[data-bike-enquiry][data-enquiry-mode="cart"]').forEach(button => {
      button.hidden = !button.closest('form')?.querySelector('[data-enquiry-bike="true"]');
    });
  };
  let visibilityQueued = false;
  const queueCartVisibility = () => {
    if (visibilityQueued) return;
    visibilityQueued = true;
    requestAnimationFrame(() => { visibilityQueued = false; syncCartButtons(); });
  };
  new MutationObserver(queueCartVisibility).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart:updated', queueCartVisibility);
  document.addEventListener('cart:build', queueCartVisibility);
  syncCartButtons();
  const summary = dialog.querySelector('#ZerodeBuildSummary');
  const status = dialog.querySelector('[data-enquiry-status]');
  const submit = dialog.querySelector('[data-enquiry-submit]');
  let opener;
  let requestVersion = 0;
  const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(amount / 100);
  const clean = value => String(value || '').replace(/[\r\n]/g, ' ').slice(0, 200);
  const sourceContext = () => {
    const url = new URL(location.href);
    const fields = ['utm_source','utm_medium','utm_campaign','utm_content'].map(key => url.searchParams.has(key) ? key + ': ' + clean(url.searchParams.get(key)) : '').filter(Boolean);
    if (document.referrer) { try { fields.push('Referrer host: ' + new URL(document.referrer).hostname); } catch {} }
    fields.push('Enquiry page: ' + url.origin + url.pathname);
    return fields.join('\n');
  };
  const properties = entries => entries.filter(([key,value]) => key.startsWith('properties[') && value && !key.startsWith('properties[_')).map(([key,value]) => key.slice(11,-1) + ': ' + clean(value));
  const open = async button => {
    if (!summary) { dialog.showModal(); return; }
    const version = ++requestVersion;
    opener = button;
    summary.value = '';
    status.textContent = '';
    submit.disabled = true;
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('#ZerodeName').focus();
    try {
      let lines = [];
      let links = [];
      if (button.dataset.enquiryMode === 'product') {
        const form = button.closest('form');
        const data = new FormData(form);
        const id = data.get('id');
        const variants = JSON.parse(form.querySelector('[data-variant-json]').value);
        const variant = variants.find(item => String(item.id) === String(id));
        if (!variant) throw new Error('variant');
        const currency = dialog.dataset.currency || 'NZD';
        const url = new URL(button.dataset.productUrl, location.origin);
        url.searchParams.set('variant', variant.id);
        lines = [button.dataset.productTitle, variant.title, money(variant.price, currency), 'Quantity: ' + (data.get('quantity') || 1), ...properties([...data.entries()])];
        links = [url.href];
      } else {
        const response = await fetch(dialog.dataset.cartUrl, {credentials:'same-origin', headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('cart');
        const cart = await response.json();
        if (!cart.items.some(item => bikeHandles.has(item.handle))) {
          if (version === requestVersion) status.textContent = dialog.dataset.empty;
          return;
        }
        lines = cart.items.flatMap(item => {
          const details = Object.entries(item.properties || {}).filter(([key,value]) => value && !key.startsWith('_')).map(([key,value]) => clean(key) + ': ' + clean(value));
          links.push(new URL(item.url, location.origin).href);
          return [item.product_title, item.variant_title || '', 'Quantity: ' + item.quantity, money(item.final_line_price, cart.currency), ...details, ''];
        });
        const note = button.closest('form')?.querySelector('[name="note"]')?.value || cart.note;
        if (note) lines.push(clean(note));
      }
      if (version !== requestVersion || !dialog.open) return;
      summary.value = lines.filter(Boolean).join('\n');
      dialog.querySelector('[data-enquiry-links]').value = links.join('\n');
      dialog.querySelector('[data-enquiry-reference]').value = 'ZB-' + crypto.randomUUID();
      dialog.querySelector('[data-enquiry-source]').value = sourceContext();
      submit.disabled = false;
    } catch {
      if (version === requestVersion) status.textContent = dialog.dataset.loadError;
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-bike-enquiry]');
    if (button) { event.preventDefault(); open(button); }
    if (event.target.closest('[data-enquiry-close]')) dialog.close();
  });
  dialog.addEventListener('close', () => { requestVersion++; opener?.focus(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
  const form = dialog.querySelector('form');
  form.addEventListener('submit', event => { if (!summary?.value || submit.disabled) event.preventDefault(); });
  if (location.hash === '#ZerodeBuildContact' && (dialog.querySelector('.errors') || dialog.querySelector('[data-enquiry-success]'))) dialog.showModal();
})();
  } catch(e) { console.error(e); }
})();

})();
